export const Client_Name = "CLIENT_NAME";
export const Client_Contact = "CLIENT_CONTACT";
export const Client_Email = "CLIENT_EMAIL";
export const Client_Address = "CLIENT_ADDRESS";
export const Client_Business_name = "CLIENT_BUSINESS_NAME";

export const findNodeWithThisPermanentCode = ({
  permanentCode,
  formsorder,
  formstate,
}) => {
  try {
    let targetNode = null;
    formsorder.some((formid) => {
      let { nodesorder, nodestate } = formstate[formid];

      nodesorder.some((nodeid) => {
        if (nodestate[nodeid].permanentcode === permanentCode) {
          targetNode = nodestate[nodeid];
          return true;
        }
        return false;
      });
      console.log("EXECUTEDDD!!!!!!!!!");

      if (targetNode) return true;
      return false;
    });

    return targetNode;
  } catch (err) {
    console.log("ERROR OCCURED AT findNodeWithThisPermanentCode function");
    return null;
  }
};
